import React from 'react';
import { useTheme } from '../context/ThemeContext.jsx';
import Footer from '../components/common/Footer.jsx';

// Visually hidden but present for screen readers and SEO; the brand name and
// tagline are baked into the lockup image.
const srOnly = {
  position: 'absolute',
  width: '1px',
  height: '1px',
  padding: 0,
  margin: '-1px',
  overflow: 'hidden',
  clip: 'rect(0, 0, 0, 0)',
  whiteSpace: 'nowrap',
  border: 0,
};

const HomePage = () => {
  const { colors } = useTheme();

  const pageStyles = {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: colors.background,
  };

  const heroStyles = {
    flex: 1,
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '24px',
  };

  const lockupStyles = {
    width: 'min(47vw, 408px)',
    height: 'auto',
  };

  return (
    <div style={pageStyles}>
      <main style={heroStyles}>
        <img
          src="/assets/logo-lockup.png"
          alt="LondaLab. Human Centered Intelligent Apps"
          style={lockupStyles}
        />
        <h1 style={srOnly}>LondaLab</h1>
        <h2 style={srOnly}>Human Centered Intelligent Apps</h2>
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
